// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"vk-z","title":"wk-z","nav":"xk-z","flexCell":"yk-z","facetLink":"zk-z"};